module.exports = __webpack_public_path__ + "img/c4463ae.jpg";